import React, { useState } from "react";
import "../styles/token-generator-dashboard.css";

export default function TokenGeneratorDashboardPage() {
  const [length, setLength] = useState(16);
  const [options, setOptions] = useState({
    lowercase: true,
    uppercase: true,
    digits: true,
    specials: true,
  });
  const [token, setToken] = useState("");
  const [success, setSuccess] = useState(false);
  const [copied, setCopied] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showInfoModal, setShowInfoModal] = useState(false); // ✅ Education Modal State

  const handleCheckbox = (key) => {
    setOptions((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  // --- LOGIQUE API (Validée) ---
  const generateToken = async () => {
    setLoading(true);
    try {
      const response = await fetch("/api/internal/generate_token", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          length: length,
          lowercase: options.lowercase,
          uppercase: options.uppercase,
          numbers: options.digits,
          symbols: options.specials
        }),
      });

      const data = await response.json();

      if (data.token) {
        setToken(data.token);
        setSuccess(true);
        setCopied(false);
      } else {
        setToken(data.error || "Erreur lors de la génération");
        setSuccess(false);
      }
    } catch (err) {
      setToken("Erreur connexion backend");
      setSuccess(false);
    } finally {
      setLoading(false);
    }
  };

  const copyToken = async () => {
    if (token && !token.startsWith("Erreur") && !token.startsWith("Veuillez")) {
      try {
        await navigator.clipboard.writeText(token);
        setCopied(true);
        setTimeout(() => setCopied(false), 3000);
      } catch (err) {
        console.error("Erreur copie:", err);
      }
    }
  };

  return (
    // --- LAYOUT TRANSPARENT (Géré par Layout.jsx) ---
    // Plus de fond d'écran ici. Juste un conteneur pour centrer la carte.
    <div style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "80vh",
      width: "100%",
      padding: "20px"
    }}>

      <div className="token-dashboard-card">
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px", marginBottom: "1rem" }}>
          <h2 style={{ margin: 0 }}>Générateur de Token Personnalisé</h2>
          <button
            onClick={() => setShowInfoModal(true)}
            style={{
              background: "rgba(0, 255, 255, 0.1)", border: "1px solid #0ff", color: "#0ff",
              borderRadius: "50%", width: "24px", height: "24px", fontSize: "0.9rem",
              cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center"
            }}
            title="Comprendre le Générateur"
          >
            i
          </button>
        </div>

        <div className="length-selector">
          <label>
            Longueur du Token (1-128)
            <input
              type="number"
              min={1}
              max={128}
              value={length}
              onChange={(e) => setLength(Number(e.target.value))}
            />
          </label>
        </div>

        <div className="token-options">
          <label>
            <input type="checkbox" checked={options.lowercase} onChange={() => handleCheckbox("lowercase")} />
            Lettres minuscules
          </label>
          <label>
            <input type="checkbox" checked={options.uppercase} onChange={() => handleCheckbox("uppercase")} />
            Lettres majuscules
          </label>
          <label>
            <input type="checkbox" checked={options.digits} onChange={() => handleCheckbox("digits")} />
            Chiffres
          </label>
          <label>
            <input type="checkbox" checked={options.specials} onChange={() => handleCheckbox("specials")} />
            Caractères spéciaux
          </label>
        </div>

        <textarea value={token} readOnly rows={3} style={token.startsWith("Erreur") || token.startsWith("Veuillez") ? { color: "#ff4d4d", borderColor: "#ff4d4d" } : {}} />

        <div className="button-group">
          <button className="copy-button btn-copy" onClick={copyToken} disabled={!token || loading || token.startsWith("Erreur") || token.startsWith("Veuillez")}>
            {copied ? "✅ Copié" : "Copier"}
          </button>
          <button onClick={generateToken} className="btn-generate" disabled={loading}>
            {loading ? "⏳..." : "Générer"}
          </button>
        </div>

        {success && !token.startsWith("Erreur") && <p className="success-msg">✅ Token généré avec succès</p>}
        {copied && <div className="feedback">✅ Copié !</div>}

        {token && success && !token.startsWith("Erreur") && !token.startsWith("Veuillez") && (
          <div style={{
            marginTop: "20px", padding: "15px", background: "rgba(255, 69, 0, 0.15)",
            border: "1px solid #ff4500", borderRadius: "8px", color: "#ffcccb",
            fontSize: "0.9rem", textAlign: "left"
          }}>
            <strong style={{ color: "#ff4500", display: "block", marginBottom: "5px" }}>⚠️ IMPORTANT</strong>
            <p style={{ margin: 0 }}>Sauvegardez ce token. Il n'est pas stocké.</p>
          </div>
        )}
      </div>

      {/* ✅ MODAL EDUCATIVE */}
      {showInfoModal && (
        <div style={{
          position: "fixed", top: 0, left: 0, width: "100%", height: "100%",
          background: "rgba(0,0,0,0.8)", backdropFilter: "blur(5px)", zIndex: 9999,
          display: "flex", justifyContent: "center", alignItems: "center"
        }} onClick={() => setShowInfoModal(false)}>
          <div style={{
            background: "rgba(20, 30, 50, 0.95)", border: "1px solid #0ff", padding: "30px", borderRadius: "16px",
            maxWidth: "600px", width: "90%", boxShadow: "0 0 50px rgba(0, 255, 255, 0.2)",
            color: "#fff", position: "relative", maxHeight: "90vh", overflowY: "auto"
          }} onClick={e => e.stopPropagation()}>

            <h2 style={{ borderBottom: "1px solid #333", paddingBottom: "10px", marginBottom: "20px", color: "#0ff" }}>
              Générateur de Haute Sécurité (Oracle)
            </h2>

            <div style={{ textAlign: "left", lineHeight: "1.6" }}>
              <h3 style={{ color: "#ffd369", marginTop: "15px" }}>1. C'est quoi ?</h3>
              <p style={{ color: "#ddd" }}>
                Ceci n'est pas un générateur de mot de passe classique. C'est une forge numérique qui utilise le
                <strong> chaos réel (Entropie Externe)</strong> pour créer des clés uniques impossibles à deviner par une Intelligence Artificielle.
              </p>

              <h3 style={{ color: "#ffd369", marginTop: "15px" }}>2. À quoi ça sert ?</h3>
              <ul style={{ color: "#ddd", paddingLeft: "20px" }}>
                <li><strong>Pour les Pros :</strong> Générer des clés API, des secrets .env, ou des identifiants de session incassables.</li>
                <li><strong>Pour les Particuliers :</strong> Créer le mot de passe "Maître" de votre gestionnaire (LastPass, Dashlane) ou sécuriser votre Wallet Crypto.</li>
              </ul>
              <p style={{ fontSize: "0.9rem", color: "#aaa", marginTop: "5px", fontStyle: "italic" }}>
                Note : Les générateurs gratuits en ligne sont souvent prédictibles. Ici, le hasard est certifié par votre propre infrastructure.
              </p>

              <h3 style={{ color: "#ffd369", marginTop: "15px" }}>3. Comment l'utiliser ?</h3>
              <ul style={{ color: "#ddd", paddingLeft: "20px" }}>
                <li><strong>Longueur :</strong> Recommandé 32 à 64 caractères pour une sécurité maximale.</li>
                <li><strong>Complexité :</strong> Utilisez "Symboles" pour un mot de passe, "Alphanumérique" pour une clé API.</li>
              </ul>

              <div style={{ marginTop: "15px", background: "#111", padding: "10px", borderRadius: "8px", borderLeft: "3px solid #0ff" }}>
                <strong>Action :</strong> Cliquez sur "Générer" et copiez immédiatement. Pour votre sécurité, nous ne stockons rien.
              </div>
            </div>

            <button onClick={() => setShowInfoModal(false)} style={{
              marginTop: "25px", width: "100%", padding: "12px", background: "#333", color: "#fff",
              border: "none", borderRadius: "8px", cursor: "pointer", fontWeight: "bold"
            }}>
              Fermer
            </button>

          </div>
        </div>
      )}

    </div>
  );
}